import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    archive: [],
    writing: null,
    allArchivesLoaded: false,
    meta: null,
    page: 1,
    noResult: false,
    
  }),
  actions,
  getters,
  mutations,
};
